





























import { Component, Prop, Vue } from "vue-property-decorator";
import mhlogo from "../assets/mh-logo.svg";
import Action from "../store/actionTypes";
import Getter from "../store/getters";

@Component({
  components: {
    mhlogo
  }
})
export default class NavBar extends Vue {
  private error: string = "";
  logout(evt: Event) {
    evt.preventDefault();
    this.$store.dispatch(Action.LOGOUT).finally(() => {
      this.$router.push({
        path: "login"
      });
    });
  }
  created() {
    console.log(this.$router.currentRoute);
  }
  is_logged_in = this.$store.getters[Getter.LOGGED_IN];
}
